export { Disclaimer as default } from './Disclaimer';